import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoanTransactionsService } from 'app/loan-transactions/loan-transactions.service';

@Injectable({
  providedIn: 'root'
})
export class LoanForeClosureTemplateResolver implements Resolve<any> {
  constructor(private loanTransactionService: LoanTransactionsService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const id = route.paramMap.get('id');
    // Call your data service to fetch the data based on the 'id'
    return this.loanTransactionService.getLoanForeclosureActionTemplate(id).pipe(
        catchError(error => {
            console.error(`Cant resolve tellers for staff`);
            return of([false]);
        })
      );
  }
}
